import * as React from 'react';
import * as ReactDOM from 'react-dom';
import {observer} from 'mobx-react';

import {CN} from '@kouch.tv/cn';

import {application, TApplicationModel} from 'src/application';

import {VideoOverlayControls} from './components/controls';
import {VideoOverlayRuntime} from './components/runtime';

import style from './style.less';
import {IReactionDisposer, reaction} from 'mobx';

const cn = CN.create('video-overlay', style);

export interface IVideoOverlayPropTypes {
	application: TApplicationModel,
}

interface IVideoOverlayStateTypes {

}

@observer
class VideoOverlay extends React.Component<IVideoOverlayPropTypes, IVideoOverlayStateTypes> {
	private _disposeLocaleReaction: IReactionDisposer;

	public componentDidMount() {
		this._disposeLocaleReaction = reaction(
			() => String(this.props.application.getModel('platform').twitch.context.locale).split('-')[0],
			(locale) => {
				this.props.application.getModel('environment')
					.setLocale(locale);
			},
			{
				fireImmediately: true,
			}
		);
	}

	public componentWillUnmount() {
		this._disposeLocaleReaction();
	}

	private _renderOverlay(): React.ReactNode {
		const {application} = this.props;

		const runtime = application.getModel('runtime');

		if (!runtime.isReadyToShow) {
			return null;
		}

		return (
			<div
				className={cn.get('overlay')}>
				{runtime.runtimes.map(this._renderOverlayRuntime)}
			</div>
		);
	}

	private _renderOverlayRuntime = (item) => {
		const {application} = this.props;

		const runtime = application.getModel('runtime');

		return (
			<div
				key={item.matchId}
				className={cn.get('overlay', 'runtime')}>
				<VideoOverlayRuntime
					id={item.matchId}
					engine={item.engine}
					markup={runtime.getData(['matches', item.matchId, 'markup', 'overlay'])}
					isVisible={item.state.isVisible} />
			</div>
		);
	}

	private _renderControls(): React.ReactNode {
		const {application} = this.props;

		return (
			<div
				className={cn.get('controls')}>
				<VideoOverlayControls
					platform={application.getModel('platform')}
					runtime={application.getModel('runtime')} />
			</div>
		);
	}

	public render(): React.ReactNode {
		return (
			<div
				className={cn.get()}>
				{this._renderOverlay()}
				{this._renderControls()}
			</div>
		);
	}
}

ReactDOM.render(
	React.createElement(VideoOverlay, {
		application: application,
	}),
	document.getElementById('b-root')
);
